import { useState, useEffect } from 'react'
import styles from './index.module.less'

interface Breakpoints {
	xs?: boolean
	sm?: boolean
	md?: boolean
	lg?: boolean
	xl?: boolean
}

type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

/**
 * Returns an object of breakpoint/boolean key/value pairs to indicate if a breakpoint fits inside the window width.
 */
const useBreakpoints = (): Breakpoints => {
	const [width, setWidth] = useState<number>(window.innerWidth)

	// Register an event listener on mount, remove on unmount, updates width on window resize
	useEffect(() => {
		const handleResize = (): void => setWidth(window.outerWidth)
		window.addEventListener('resize', handleResize)
		return (): void => window.removeEventListener('resize', handleResize)
	}, [])

	return Object.entries(styles).reduce<Breakpoints>((breakpoints, [size, value]) => {
		// remove 'px' and convert to number
		const breakpoint = Number(value.slice(0, -2))
		breakpoints[size as Breakpoint] = breakpoint > width
		return breakpoints
	}, {})
}

export default useBreakpoints
